<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.lowongan }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="8" md="8" lg="8">
            <CButton class="mb-4 btn-primary" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </CButton>
          </CCol>
          <CCol cols="2" md="2" lg="2">
            <CButton block class="mb-4 btn-outline-success mr-2" @click="copyData('lowongan kerja')">
              <b-icon icon="files" />
              Vacancy
            </CButton>
          </CCol>
          <CCol cols="2" md="2" lg="2">
            <CButton block class="mb-4 btn-outline-warning mr-2" @click="copyData('login lowongan kerja')">
              <b-icon icon="files" />
              Vacancy Login
            </CButton>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #tglAkhir-filter>
                <DatePicker style="width: 100%" v-model="filter.tanggalAkhirLoker" format="DD MMMM YYYY"></DatePicker>
              </template>
              <template #Actions="{ item }">
                <td>
                  <CButton class="mr-1 mb-1 btn-info" v-c-tooltip.hover.click="'Detail'" v-b-modal.modal-detail @click="data = item"><CIcon name="cil-info" /> {{ item.actions }}</CButton>
                  <CButton
                    class="mr-1 mb-1 btn-warning"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="(data = item), (edit = true)"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-pencil" /> {{ item.actions }}</CButton
                  >
                  <CButton
                    class="mr-1 mb-1 btn-danger"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-trash" /> {{ item.actions }}</CButton
                  >
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input @alertFromChild="triggerAlert($event)" :divisi="divisi" :dokumen="dokumen" />
    <modal-edit :data="data" :divisi="divisi" :dokumen="dokumen" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-detail :data="data" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
import modalDetail from "./modalDetail.vue";
export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
    modalDetail,
  },
  name: "lowongan",
  data() {
    return {
      divisi: [],
      dokumen: [],
      edit: false,
      data: {},
      items: [],
      filter: {
        tanggalAkhirLoker: null,
      },
      partner: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    mitra_aktif() {
      return this.$store.state.mitra_aktif;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaLoker",
          label: this.$store.state.table.namaLoker,
          _style: "max-width: 45%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaPosisi",
          label: this.$store.state.table.namaPosisi,
          _style: "width: 30%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "tglAkhir",
          label: this.$store.state.table.tglAkhir,
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 15%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];

      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
    copy() {
      const vm = this;
      let main;
      if (window.location.hostname === "localhost") {
        main = window.location.origin;
      } else {
        main = `https://${window.location.hostname}`;
      }
      const companyId = vm.mitra_aktif?.id || vm.partner?.id;

      const query = `?company=${companyId}&kode=${vm.$store.state.kode_client}`;

      return {
        "lowongan kerja": `${main}/loker${query}`,
        "login lowongan kerja": `${main}/loginToken${query}`,
      };
    },
  },
  mounted() {
    this.getDatas();
    this.getDivisi();
    this.getKebutuhan();
    this.getMitra()
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalAkhirLoker"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getMitra() {
      const vm = this;
      vm.loading = true;
      let listMitra = await vm.$axios.post("mitra/listPerHalaman", {
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listMitra", listMitra);
      vm.partner = listMitra.data.data[0];
    },
    async copyData(x) {
      const vm = this;
      // console.log(window.location.origin)
      await navigator.clipboard.writeText(vm.copy[x]);
      vm.$store.commit("set_alert", {
        variant: "success",
        msg: `Success copy ${x}`,
        showing: true,
      });
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listLoker = await vm.$axios.post("/loker/listPerHalaman", {
        ...vm.filter,
        tanggalAkhirLoker: vm.filter.tanggalAkhirLoker ? vm.$moment(vm.filter.tanggalAkhirLoker).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listLoker", listLoker);
      vm.items =
        listLoker.data.status == 200
          ? listLoker.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.lokerId,
                namaMitra: x.namaMitra || " - ",
                tglAkhir: vm.$moment(x.tanggalAkhirLoker).format("LL"),
                //edit
                posisi: { namaPosisi: x.namaPosisi, masterPosisiId: x.masterPosisiId },
                masterDivisiId: { namaDivisi: x.namaDivisi, masterDivisiId: x.masterDivisiId },
              };
            })
          : [];
      vm.totalRows = parseInt(listLoker.data.count);
      vm.loading = false;
    },
    async getKebutuhan() {
      let vm = this;
      let listKebutuhan = await vm.$axios.post("masterKebutuhan/list");
      vm.dokumen =
        listKebutuhan.data.status == 200
          ? listKebutuhan.data.data.map((x) => {
              return {
                ...x,
                id: x.masterKebutuhanId,
              };
            })
          : [];
    },
    async getDivisi() {
      let vm = this;
      let divisi = await vm.$axios.post("masterDivisi/list");
      console.log(divisi.data.data, "divisi");
      vm.divisi =
        divisi.data.status == 200
          ? divisi.data.data.map((x) => {
              return {
                ...x,
                id: x.masterDivisiId,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
